export const snackTypes = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
}

export const AssessmentTypesEnum = ['form', 'info', 'instruction', 'quiz', 'thankyou'];
